import TextInput, { InputLabel } from 'components/Input/TextInput';
import { ReportFilter } from 'models/report';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  filter: ReportFilter;
  selectedManualFilters: ReportFilter[];
  setSelectedManualFilters: (filters: ReportFilter[]) => void;
  requiredMissingValues?: { [key: string]: string };
}

export const InputRange = (props: Props) => {
  const t = utils.intl.useTranslator();

  const { filter, setSelectedManualFilters, selectedManualFilters, requiredMissingValues } = props;

  const [fromRange, setFromRange] = useState<string | number | null>(null);
  const [toRange, setToRange] = useState<string | number | null>(null);

  const onChangeFromRange = (e: any) => {
    setFromRange(e.target.value);
    const newFilters = [...selectedManualFilters];
    const newItem = selectedManualFilters.find(({ column }) => column === filter.column);
    if (newItem) {
      newItem.listOfValues = [
        e.target.value ? { code: e.target.value as string, name: '' } : null,
        toRange ? { code: toRange as string, name: '' } : null,
      ].filter(Boolean) as { code: string; name: string }[];
    }
    setSelectedManualFilters(newFilters);
  };

  const onChangeToRange = (e: any) => {
    setToRange(e.target.value);
    const newFilters = [...selectedManualFilters];
    const newItem = selectedManualFilters.find(({ column }) => column === filter.column);
    if (newItem) {
      newItem.listOfValues = [
        fromRange ? { code: fromRange as string, name: '' } : null,
        e.target.value ? { code: e.target.value as string, name: '' } : null,
      ].filter(Boolean) as { code: string; name: string }[];
    }
    setSelectedManualFilters(newFilters);
  };

  const selectedFilter = selectedManualFilters.find(({ column }) => column === filter.column);
  const listOfValues = selectedFilter?.listOfValues || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Wrapper style={{ marginBottom: '15px' }}>
        <InputLabel style={{ width: '10%' }}>{t('from')}</InputLabel>
        <TextInput
          id={`input-range-from-${filter.column}`}
          value={listOfValues && listOfValues.length ? listOfValues[0].code : ''}
          hasFeedback={Boolean(requiredMissingValues && requiredMissingValues[filter.column])}
          feedbackMessage={requiredMissingValues && requiredMissingValues[filter.column]}
          placeholder={filter.filterColumnName}
          type={filter.typeOfValue === 'NUMERIC' ? 'number' : 'text'}
          onChange={(e: any) => {
            onChangeFromRange(e);
          }}
          width="125px"
        />
      </Wrapper>
      <Wrapper>
        <InputLabel style={{ width: '10%', textAlign: 'left' }}>{t('to')}</InputLabel>
        <TextInput
          id={`input-range-to-${filter.column}`}
          value={listOfValues && listOfValues.length > 1 ? listOfValues[1].code : ''}
          hasFeedback={Boolean(requiredMissingValues && requiredMissingValues[filter.column])}
          feedbackMessage={requiredMissingValues && requiredMissingValues[filter.column]}
          placeholder={filter.filterColumnName}
          type={filter.typeOfValue === 'NUMERIC' ? 'number' : 'text'}
          onChange={(e: any) => {
            onChangeToRange(e);
          }}
          width="125px"
        />
      </Wrapper>
    </div>
  );
};
